import { useStyles } from "@b2bportal/core-themes";
import { type ApacFlightsComponent, APAC_FLIGHT_NAME } from "@apac/flights";

export const useApacFlightsStyles = (
  componentName: keyof typeof ApacFlightsComponent,
  defaultStyles?: object
) => {
  return useStyles(APAC_FLIGHT_NAME, componentName, defaultStyles);
};
